'use strict';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';

PopoverSelectController.$inject = [
  '$scope',
  '$element',
  '$attrs',
  'HashMap',
  '$rootScope',
  '$selectOptions',
  '$popover',
  'popoverSelectTemplateService',
];

const noopNgModelController = {$setViewValue: noop, $render: noop};

// TODO: add support for selecting none if allowed (attribute). Configure with attributes for null value and display
export function PopoverSelectController(
  $scope,
  $element,
  $attrs,
  HashMap,
  $rootScope,
  $selectOptions,
  $popover,
  popoverSelectTemplateService,
) {
  const ngOptions = $selectOptions.parseOptionsExpression($attrs.options, $scope, $attrs);

  let popoverScope;
  let optionsPopover;
  let currentTemplate;
  let options;

  // If the ngModel isn't available yet, provide a dummy noop version to prevent errors
  this.ngModelCtrl = noopNgModelController;

  this.renderUnknownOption = val => {
    $element.value = `? ${HashMap.hashKey(val)} ?`;
    $element.text(val);
  };

  $scope.$on('$destroy', () => {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    this.renderUnknownOption = noop;
    cleanupPopover();
  });

  /* eslint-disable lodash/prefer-noop */
  this.removeUnknownOption = () => {
    // if (this.unknownOption.parent()) this.unknownOption.remove();
  };
  /* eslint-enable lodash/prefer-noop */


  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  this.readValue = () => {
    // this.removeUnknownOption();
    return this.ngModelCtrl.$modelValue;
  };

  this.writeValue = value => {
    let option = options.getOptionFromViewValue(value);

    if (option) {
      if ($element.text() !== option.label) {
        // removeUnknownOption();
        // removeEmptyOption();

        // Not entirely sure this is necessary. emulating original behavior
        !option.disabled && this.ngModelCtrl.$setViewValue(value);
        $element.text(option.label);
        // option.element.selected = true;
        // option.element.setAttribute('selected', 'selected');
      }
    } else {
      option = options.getNullOption();
      this.ngModelCtrl.$setViewValue(value);
      $element.text(option.label || '');

      // if (value === null || $attrs.nullable) {
      //  this.removeUnknownOption();
      //  this.renderEmptyOption();
      // } else {
      //  this.removeEmptyOption();
      //  this.renderUnknownOption();
      // }
    }
  };

  // this.readValue = () => {
  //
  //  var selectedOption = options.selectValueMap[this.ngModelCtrl.$modelValue];
  //  console.log('selectedOption', selectedOption);
  //
  //  if (selectedOption && !selectedOption.disabled) {
  //    //this.removeEmptyOption();
  //    //this.removeUnknownOption();
  //    return options.getViewValueFromOption(selectedOption);
  //  }
  //  return null;
  // };

  // If we are using `track by` then we must watch the tracked value on the model
  // since ngModel only watches for object identity change
  if (ngOptions.trackBy) {
    $scope.$watch(
      () => ngOptions.getTrackByValue(this.ngModelCtrl.$viewValue),
      () => this.ngModelCtrl.$render()
    );
  }


  this.showOptions = $event => {
    updateSelection();
    optionsPopover.show($event);
  };

  const selectOption = value => {
    const option = options.selectValueMap[value];
    this.writeValue(option ? option.viewValue : null);
    updateSelection();

    optionsPopover.hide();
  };

  const updateOptions = () => {
    options = ngOptions.getOptions();
    const template = popoverSelectTemplateService.generatePopoverTemplate({
      nullable: $attrs.nullable,
      multiple: $attrs.multiple,
      ...options,
    });
    if (!currentTemplate || currentTemplate !== template) {
      cleanupPopover();
      createPopover(template);
    }
    this.ngModelCtrl.$render();
  };

  const updateSelection = () => {
    popoverScope.selection = this.readValue();
  };

  const createPopover = template => {
    currentTemplate = template;
    popoverScope = $rootScope.$new();
    popoverScope.select = selectOption;
    optionsPopover = $popover.fromTemplate(template, {
      scope: popoverScope,
    });
  };

  const cleanupPopover = () => {
    if (optionsPopover && isFunction(optionsPopover.remove)) {
      optionsPopover.remove();
    }
    if (popoverScope) {
      popoverScope.$destroy();
    }
  };

  updateOptions();

  $scope.$watchCollection(ngOptions.getWatchables, updateOptions);
}



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/PopoverSelectController.js